// Çalışan Yönetimi sayfası ve yeni Çalışan Ekle / Düzenle pencereleri.
const employees = {
  title: 'Çalışan Yönetimi',
  subtitle: 'Çalışanları arayın, filtreleyin ve seçtiğiniz kişi üzerinde işlem yapın.',
  listLabel: 'Çalışan listesi',
  actions: {
    pendingLeaves: 'Bekleyen İzin Talepleri: {{count}}',
    missingDocs: 'Eksik Belgeler',
    missingDocsHint: 'Zorunlu CV/GCP/IATA belgesi eksik olan aktif çalışanlar',
    download: 'Tabloyu İndir',
    downloadHint: 'Tabloyu İndir (Excel)',
    addEmployee: 'Yeni Çalışan Ekle',
  },
  stats: {
    total: 'Toplam Çalışan',
    totalShort: 'Toplam',
    active: 'Aktif Çalışan',
    activeShort: 'Aktif',
    inactive: 'İnaktif Çalışan',
    inactiveShort: 'İnaktif',
    share: 'Tüm çalışanlar içindeki payı: %{{percent}}',
  },
  status: {
    active: 'Aktif',
    inactive: 'İnaktif',
    all: 'Tümü',
  },
  yes: 'Evet',
  no: 'Hayır',
  columns: {
    eName: 'Ad',
    eSurname: 'Soyad',
    tcNumber: 'TC No',
    phone: 'Telefon',
    eMail: 'E-posta',
    departman: 'Departman',
    profession: 'Meslek',
    workType: 'Çalışma Şekli',
    startDate: 'Başlangıç Tarihi',
    Active: 'Durum',
    employeeExitDate: 'İşten Ayrılma Tarihi',
    address: 'Ev Adresi',
    workAddress: 'İş Adresi',
    annualPermit: 'Yıllık İzin',
    birthday: 'Doğum Tarihi',
    isHandicappedPerson: 'Engellilik Durumu',
    isIntern: 'Stajyer',
    isRetired: 'Emekli',
    languageInfo: 'Dil Bilgisi',
    nationality: 'Uyruk',
    educationInfo: 'Eğitim Bilgisi',
  },
  options: {
    fullTime: 'Tam Zamanlı',
    partTime: 'Yarı Zamanlı',
    education: {
      secondary: 'Ortaokul / Ortaöğretim',
      highSchool: 'Lise',
      associate: 'Ön Lisans (2 Yıllık Üniversite)',
      bachelor: 'Lisans (4 Yıllık Üniversite)',
      master: 'Yüksek Lisans (Master)',
      phd: 'Doktora (PhD)',
    },
  },
  toolbar: {
    searchPlaceholder: 'İsim, soyisim veya TC no ile ara…',
    searchPlaceholderShort: 'Ad, soyad veya TC ara…',
    searchLabel: 'Çalışan ara (en az 3 karakter)',
    minChars: 'En az 3 karakter',
    clearSearch: 'Aramayı temizle',
    statusLabel: 'Durum filtresi',
    filters: 'Filtreler',
    filtersOpen: 'Filtreler ({{count}} açık)',
    clearAll: 'Tümünü Temizle',
    removeFilter: '{{label}} filtresini kaldır',
    pendingFilter: 'Bu filtre en az 3 karakterle uygulanır',
  },
  columnsMenu: {
    button: 'Sütunlar',
    buttonLabel: 'Sütunlar ({{count}}/{{total}} görünür)',
    title: 'Sütun Görünürlüğü',
    visible: '{{count}} / {{total}} görünür',
    showAll: 'Tümünü göster',
    reset: 'Varsayılana dön',
    resetHint: 'Varsayılan sütunlar ve genişlikler',
    lastColumn: 'En az bir sütun görünür kalmalı',
    hiddenWhenActive: 'Aktif’te gizli',
    hiddenWhenActiveHint: 'Durum filtresi “Aktif” iken bu sütun gizlenir',
  },
  filter: {
    title: '{{label}} filtresi',
    titleOn: '{{label}} filtresi (açık)',
    placeholder: 'Ara…',
    clear: 'Temizle',
    minChars: 'En az 3 karakter girin',
    all: 'Tümü',
  },
  table: {
    label: 'Çalışanlar',
    resizeLabel: '{{label}} sütununun genişliği',
    resizeHint: 'Genişliği değiştirmek için sürükleyin, sıfırlamak için çift tıklayın',
    scrollLeft: 'Tabloyu sola kaydır',
    scrollRight: 'Tabloyu sağa kaydır',
    empty: 'Filtrelere uygun çalışan bulunamadı',
    noColumns: 'Görünür sütun yok',
    showDefaultColumns: 'Varsayılan sütunları göster',
    clearFilters: 'Filtreleri Temizle',
    pendingLeave: 'Bekleyen izin talebi: {{count}}',
    pendingLeaveSr: 'bekleyen izin talebi',
    primaryAddress: 'Ana Adres',
    loading: 'Çalışanlar yükleniyor',
  },
  pagination: {
    rangeOf: '/ {{total}} çalışan',
    ofTotal: 'toplam {{total}} çalışan içinden',
    noResults: 'Sonuç yok',
    loading: 'Yükleniyor…',
    pages: 'Sayfalar',
    first: 'İlk sayfa',
    previous: 'Önceki sayfa',
    next: 'Sonraki sayfa',
    last: 'Son sayfa',
    page: 'Sayfa {{page}}',
  },
  panel: {
    label: 'Seçili çalışan',
    heading: 'Çalışan',
    previous: 'Önceki çalışan',
    next: 'Sonraki çalışan',
    close: 'Kapat (Esc)',
    actions: 'İşlemler',
    details: 'Bilgiler',
    card: 'Çalışan Kartı',
    edit: 'Düzenle',
    files: 'Dosyalar',
    projects: 'Projeler',
    accountCreate: 'Hesap Oluştur',
    accountCreateHint: 'Çalışan için kullanıcı hesabı oluştur',
    accountChecking: 'Kontrol…',
    accountCheckingHint: 'Kullanıcı durumu kontrol ediliyor…',
    accountExists: 'Hesap Var',
    accountExistsHint: 'Bu çalışan için zaten bir kullanıcı hesabı var',
    deactivate: 'İnaktif Yap',
    activate: 'Aktif Yap',
    statusHint: 'Durum Değiştir',
    pendingLeaves: '{{count}} bekleyen izin talebi',
    copy: 'Kopyala',
    copyLabel: '{{label}} kopyala',
    copied: '{{label}} kopyalandı',
    copyFailed: 'Panoya kopyalanamadı',
    primaryAddress: 'Ana Adres · {{label}}',
  },
  filterSheet: {
    subtitle: 'Listeyi sütunlara göre daraltın',
    show: '{{count}} sonucu göster',
  },
  toast: {
    loadError: 'Çalışanlar yüklenirken hata oluştu',
    activated: 'Çalışan aktif yapıldı ve tüm projelerinde aktif duruma geçirildi',
    statusError: 'Durum güncellenirken hata oluştu',
    userCheckError: 'Kullanıcı durumu kontrol edilirken hata oluştu.',
    leaveDeleted: 'İzin talebi başarıyla silindi',
    leaveDeleteError: 'İzin talebi silinirken hata oluştu',
    excelPreparing: 'Excel dosyası hazırlanıyor…',
    excelSuccess: 'Excel dosyası başarıyla indirildi',
    excelError: 'Excel dosyası indirilirken hata oluştu',
  },
  form: {
    addTitle: 'Yeni Çalışan Ekle',
    addSubtitle: '* ile işaretli alanlar zorunludur',
    editTitle: 'Çalışanı Düzenle',
    sections: 'Form bölümleri',
    stepOf: '{{current}} / {{total}}',
    personal: 'Kişisel Bilgiler',
    personalHint: 'Kimlik ve temel bilgiler',
    contact: 'İletişim',
    contactHint: 'E-posta, telefon ve adresler',
    employment: 'İş Bilgileri',
    employmentHint: 'Departman, rol, yetki ve çalışma düzeni',
    education: 'Eğitim ve Dil',
    educationHint: 'Eğitim seviyesi ve yabancı diller',
    fields: {
      ID: 'Sicil Numarası',
      eName: 'Ad',
      eSurname: 'Soyad',
      tcNumber: 'TC Kimlik No',
      nationality: 'Uyruk',
      birthday: 'Doğum Tarihi',
      eMail: 'E-posta',
      phone: 'Telefon',
      emergencyPhone: 'Acil Durum Telefonu',
      address: 'Ev Adresi',
      workAddress: 'İş Adresi',
      departman: 'Departman',
      profession: 'Meslek',
      role: 'Çalışan Rolü',
      authorization: 'Yetki',
      workType: 'Çalışma Şekli',
      Active: 'Durum',
      startDate: 'İşe Başlama Tarihi',
      annualPermit: 'Yıllık İzin (gün)',
      educationInfo: 'Eğitim Bilgisi',
      languageInfo: 'Dil Bilgisi',
      isHandicappedPerson: 'Engelli',
      isRetired: 'Emekli',
      isIntern: 'Stajyer',
    },
    choose: 'Seçiniz',
    outOfList: '{{value}} (liste dışı)',
    loadingDepartments: 'Departmanlar yükleniyor…',
    loadingRoles: 'Roller yükleniyor…',
    authorizationLocked: 'Bu alanı yalnızca süper admin düzenleyebilir',
    roleNotInList: 'Mevcut rol listede yok; eğitim ve SOP atamaları bu rolle eşleşmez.',
    phonePlaceholder: '5XX XXX XX XX',
    emergencyPlaceholder: '5XX XXX XX XX (opsiyonel)',
    phoneExample: 'Örn: 532 123 45 67',
    emergencyExample: 'Acil durum için telefon (opsiyonel)',
    flags: 'Durumlar',
    email: {
      placeholder: 'ad.soyad',
      hint: 'Yalnızca adresin başını yazın; uzantı otomatik eklenir.',
      preview: 'Kaydedilecek adres: {{email}}',
      invalid: 'Yalnızca İngilizce harf, rakam ve . _ - + kullanılabilir.',
      external: 'Şirket dışı adres',
      externalHint: 'Bu adres olduğu gibi korunur.',
      convert: '@{{domain}} adresine çevir',
    },
    languages: {
      language: 'Dil',
      level: 'Seviye',
      chooseLanguage: 'Dil seçiniz',
      chooseLevel: 'Seviye',
      native: 'Ana Dil',
      add: 'Dil Ekle',
      remove: 'Bu dili kaldır',
      empty: 'Henüz dil eklenmedi.',
    },
    required: 'Bu alan zorunludur',
    phoneInvalid: 'Telefon 10 haneli olmalı (5XX XXX XX XX)',
    fixErrors: 'Lütfen işaretli alanları düzeltin.',
    back: 'Geri',
    nextSection: 'İleri',
    cancel: 'İptal',
    saveNew: 'Çalışanı Kaydet',
    save: 'Kaydet',
    saving: 'Kaydediliyor…',
    unsaved: 'Kaydedilmemiş değişiklikler var.',
    keepEditing: 'Düzenlemeye dön',
    discard: 'Kaydetmeden kapat',
    duplicateEmail: 'Bu e-posta adresi ile kayıtlı bir çalışan zaten mevcut!',
    added: 'Çalışan başarıyla eklendi!',
    addError: 'Çalışan eklenirken bir hata oluştu!',
    updated: 'Çalışan bilgileri başarıyla güncellendi',
    updateError: 'Çalışan güncellenirken hata oluştu: {{message}}',
    departmentsError: 'Departmanlar yüklenirken bir hata oluştu.',
    rolesError: 'Yetkilendirme rolleri yüklenirken bir hata oluştu.',
  },
  // Çalışan Yönetimi'nden açılan diğer pencereler
  modals: {
    card: {
      title: 'Çalışan Kartı',
      personal: 'Kişisel Bilgiler',
      contact: 'İletişim',
      work: 'İş Bilgileri',
      addresses: 'Adresler',
      age: '{{age}} yaşında',
      photoAlt: '{{name}} fotoğrafı',
      edit: 'Düzenle',
    },
    files: {
      title: 'Dosyalar',
      category: 'Dosya türü',
      chooseCategory: 'Önce dosya türünü seçin',
      alreadyUploaded: 'Bu türde bir dosya zaten var; yenisini yüklemek için önce mevcut dosyayı silin.',
      uploadedMark: '{{label}} · yüklü',
      drop: 'Dosyaları buraya sürükleyin',
      or: 'veya',
      browse: 'Dosya Seçin',
      uploading: 'Yükleniyor…',
      accepted: 'PDF, Word, Excel ve görseller',
      uploadedTab: 'Yüklenen Dosyalar',
      cvTab: 'CV / GCP / IATA',
      uncategorized: 'Kategorisiz',
      none: 'Bu çalışanın hiç dosyası bulunmamakta.',
      cvNone: 'Bu çalışanın CV/GCP/IATA belgesi bulunmamakta.',
      cvHint: 'Bu belgeleri çalışan kendi profilinden yükler.',
      open: 'Dosyayı aç',
      view: 'Görüntüle',
      download: 'Dosyayı İndir',
      delete: 'Dosyayı Sil',
      confirmDelete: 'Silinsin mi?',
      confirm: 'Sil',
      cancel: 'Vazgeç',
      loading: 'Yükleniyor…',
      exitReason: '{{name}} için işten ayrılış sözleşmesi yüklendi. Çıkışı tamamlamak için ayrılma tarihini girin.',
      toast: {
        chooseCategory: 'Lütfen dosya türünü seçiniz!',
        duplicate: 'Bu dosya türü ({{category}}) zaten yüklenmiş! Önce mevcut dosyayı silin.',
        uploaded: 'Dosyalar başarıyla yüklendi!',
        uploadError: 'Dosya yükleme hatası!',
        deleted: 'Dosya başarıyla silindi!',
        deleteError: 'Dosya silinirken bir hata oluştu!',
      },
    },
    exit: {
      title: 'İşten Ayrılma Tarihi',
      label: '{{name}} çalışanının işten ayrılma tarihi',
      effect: 'Kaydedildiğinde çalışan pasife alınır, sisteme giriş yetkisi kalkar ve tüm projelerdeki atamaları pasife düşer.',
      required: 'Lütfen işten ayrılma tarihini seçin',
      saved: 'Çalışan durumu İnaktif olarak güncellendi, işten ayrılma tarihi kaydedildi ve tüm projelerden pasif duruma geçirildi',
      error: 'Durum güncellenirken hata oluştu',
    },
    account: {
      title: 'Kullanıcı Hesabı Oluştur',
      subtitle: 'Çalışan için portal hesabı',
      noEmail: 'Bu çalışanın e-posta adresi yok. Hesap e-posta ile açıldığı için önce Düzenle bölümünden adres ekleyin.',
      password: 'Şifre',
      confirmPassword: 'Şifreyi Onayla',
      generate: 'Oluştur',
      generateHint: 'Güçlü Şifre Oluştur',
      copy: 'Şifreyi kopyala',
      copied: 'Şifre kopyalandı',
      copyFailed: 'Şifre kopyalanamadı',
      match: 'Şifreler eşleşiyor',
      noMatch: 'Şifreler eşleşmiyor',
      role: 'Rol',
      roles: {
        employee: 'Çalışan',
        admin: 'Yönetici',
        finance: 'Finans Yöneticisi',
        project: 'Proje Yöneticisi',
        fieldCoordinator: 'Saha Koordinatörü',
        hr: 'İnsan Kaynakları',
        smoLead: 'SMO Lead',
      },
      mailNote: 'Giriş bilgileri çalışanın e-posta adresine gönderilir.',
      submit: 'Kullanıcı Oluştur',
      creating: 'Oluşturuluyor…',
      errors: {
        mismatch: 'Şifreler eşleşmiyor veya boş.',
        short: 'Şifre en az 6 karakter olmalıdır.',
        emailInUse: 'Bu e-posta adresi zaten başka bir kullanıcı tarafından kullanılıyor.',
        invalidEmail: 'Geçersiz e-posta formatı.',
        weak: 'Şifre yeterince güçlü değil.',
        generic: 'Kullanıcı oluşturulurken bir hata oluştu: {{message}}',
      },
      toast: {
        createdAndMailed: 'Kullanıcı oluşturuldu ve giriş bilgileri e-posta ile gönderildi.',
        mailFailed: 'Kullanıcı oluşturuldu fakat e-posta gönderilemedi. Lütfen bilgileri manuel iletiniz.',
        created: 'Kullanıcı {{email}} başarıyla oluşturuldu. Admin oturumu devam ediyor.',
        emailInUse: 'E-posta zaten kullanımda.',
        invalidEmail: 'Geçersiz e-posta.',
        weak: 'Şifre zayıf.',
        generic: 'Kullanıcı oluşturma hatası.',
      },
    },
    missingDocs: {
      title: 'Eksik Belgesi Olan Çalışanlar',
      subtitle: '{{count}} aktif çalışan',
      hint: 'Aktif çalışanlar için zorunlu CV/GCP/IATA belgeleri kontrol edilir. Belgeleri çalışan kendi profilinden yükler.',
      search: 'Çalışan ara…',
      loadError: 'Eksik belgeler yüklenirken bir hata oluştu.',
      noMatch: 'Aramaya uygun çalışan bulunamadı.',
      none: 'Eksik belgesi olan çalışan bulunmamaktadır.',
      openFiles: 'Dosyalar',
      openFilesHint: 'Çalışanın dosyalarını aç',
    },
    pendingLeaves: {
      title: 'Bekleyen İzin Talepleri',
      subtitle: '{{count}} talep onay bekliyor',
      none: 'Bekleyen izin talebi bulunmamaktadır.',
      unknownEmployee: 'Bilinmeyen Çalışan',
      days: '{{count}} gün',
      focus: 'Çalışana git',
      focusHint: 'Tıklayarak çalışana odaklan',
      delete: 'Sil',
      deleteHint: 'İzin talebini sil',
      confirmDelete: 'Silinsin mi?',
      cancel: 'Vazgeç',
      types: {
        yillik: 'Yıllık İzin',
        mazeret: 'Mazeret İzni',
        raporlu: 'Raporlu',
      },
    },
  },
  fileCategories: {
    idCopy: 'Nüfus Cüzdanı Fotokopisi',
    residence: 'İkametgah',
    criminalRecord: 'Adli Sicil Kaydı',
    healthReport: 'Sağlık Raporu',
    registry: 'Nüfus Kayıt Örneği',
    familyStatus: 'Aile Durumu Bildirimi',
    highSchool: 'Lise Diploma',
    bachelor: 'Lisans Diploma',
    master: 'Yüksek Lisans Diploma',
    phd: 'Doktora Diploma',
    sgk: 'SGK Giriş Bildirgesi',
    employmentContract: 'İşe Giriş Sözleşme',
    exitContract: 'İşten Ayrılış Sözleşme',
    bloodCard: 'Kan Kartı',
    photo: 'Resim',
    certificate: 'Sertifika',
    associate: 'Ön Lisans Diploma',
    other: 'Diğer',
  },
  cvTypes: {
    cvTr: 'Türkçe CV',
    cvEn: 'İngilizce CV',
    gcp: 'GCP',
    iata: 'IATA',
  },
  // Kayıtlı değerler Türkçe kalır; burada yalnızca görünen adlar var.
  nationalities: {
    turkish: 'Türk',
    afghan: 'Afganlı',
    german: 'Alman',
    american: 'Amerikalı',
    arab: 'Arap',
    albanian: 'Arnavut',
    azerbaijani: 'Azeri',
    belgian: 'Belçikalı',
    bosnian: 'Boşnak',
    bulgarian: 'Bulgar',
    chinese: 'Çinli',
    french: 'Fransız',
    georgian: 'Gürcü',
    indian: 'Hintli',
    dutch: 'Hollandalı',
    british: 'İngiliz',
    iranian: 'İranlı',
    spanish: 'İspanyol',
    swedish: 'İsveçli',
    italian: 'İtalyan',
    japanese: 'Japon',
    kazakh: 'Kazak',
    kyrgyz: 'Kırgız',
    korean: 'Koreli',
    lebanese: 'Lübnanlı',
    macedonian: 'Makedon',
    egyptian: 'Mısırlı',
    moldovan: 'Moldovalı',
    uzbek: 'Özbek',
    pakistani: 'Pakistanlı',
    polish: 'Polonyalı',
    portuguese: 'Portekizli',
    romanian: 'Romanyalı',
    russian: 'Rus',
    serbian: 'Sırp',
    syrian: 'Suriyeli',
    tajik: 'Tacik',
    tunisian: 'Tunuslu',
    turkmen: 'Türkmen',
    ukrainian: 'Ukraynalı',
    jordanian: 'Ürdünlü',
    greek: 'Yunan',
    other: 'Diğer',
  },
  languageNames: {
    english: 'İngilizce',
    german: 'Almanca',
    french: 'Fransızca',
    spanish: 'İspanyolca',
    italian: 'İtalyanca',
    russian: 'Rusça',
    arabic: 'Arapça',
    persian: 'Farsça',
    chinese: 'Çince',
    japanese: 'Japonca',
    korean: 'Korece',
    portuguese: 'Portekizce',
    dutch: 'Hollandaca',
    greek: 'Yunanca',
    azerbaijani: 'Azerice',
    turkish: 'Türkçe',
    other: 'Diğer',
  },
};

export default employees;
